import type { GetAbsoluteUrlOptions } from '@segment/utils/getAbsoluteUrl'
import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

type ResourceProps = {
  badge: string
  title: string
  description: string
  buttonText: string
  buttonUrl: string
}

const getResources = (pageConfig: GetAbsoluteUrlOptions): ResourceProps[] => [
  {
    badge: `Report`,
    title: `The Growth Report: AI edition`,
    description: `In Twilio Segment’s third annual Growth Report, we surveyed 2,450 marketing, CX, and data leaders from across industries to explore what it means to grow sustainably, and how companies are using AI to do just that.`,
    buttonText: `Read the report`,
    buttonUrl: getAbsoluteUrl(`/the-growth-report/`, pageConfig),
  },
  {
    badge: `Webinar`,
    title: `How to Master Customer Engagement in the AI Era with Data`,
    description: `In this webinar, discover how Segment CDP becomes the center of your AI models to help generate intelligent responses, anticipate customer needs, and drive conversion rates like never before.`,
    buttonText: `Watch the webinar`,
    buttonUrl: `https://webinars.segment.com/segment/how-to-master-customer-engagement-in-the-ai-era-with-data/`,
  },
  {
    badge: `Webinar`,
    title: `How to Fuel Efficient Growth with AI-driven Personalization`,
    description: `In this interactive session, we’ll demonstrate step-by-step how Twilio Segment’s leading CDP helps to collect, clean, and activate data so businesses can leverage AI applications to their fullest potential.`,
    buttonText: `Watch the product tour`,
    buttonUrl: `https://webinars.segment.com/segment/fuel-sustained-growth-with-ai/`,
  },
]

export default getResources
